export const GET_BOOKABLE_RESOURCE = 'GET_BOOKABLE_RESOURCE';
export const BOOKABLE_RESOURCE_LOADING = 'BOOKABLE_RESOURCE_LOADING';
export const UPDATE_BOOKABLE_RESOURCE = 'UPDATE_BOOKABLE_RESOURCE';
export const BOOKABLE_RESOURCE_ERROR = 'BOOKABLE_RESOURCE_ERROR';
